/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Button, Checkbox } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomTextInput, CustomFileInput, CustomText } from 'src/components'
import { showNotification, extractFormData, getFileFromBlobUrl } from 'src/core/helpers'
import {
  resetWithdrawPayPalState,
  summaryWithdrawSelector,
  userAuthenticatedState,
  createWithdrawPayPal,
  getBalance,
} from 'src/features'

interface WithDrawPayPalFormProps {
  amount: number
  selectCurrencyId: number
  handleCancel: () => void
}

const WithDrawPayPalForm: React.FC<WithDrawPayPalFormProps> = ({ amount, selectCurrencyId, handleCancel }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [form] = Form.useForm()
  const [showInvoiceField, setShowInvoiceField] = useState(false)
  const { loading, success, error } = useAppSelector(summaryWithdrawSelector)
  const user = useAppSelector(userAuthenticatedState)

  const onSubmit = async (values: { email: string, certificate: string, partnership_invoice?: string }) => {
    const payload = {
      amount: amount,
      currency_token: selectCurrencyId,
      kind: 'paypal',
      cancellation_certificate: values.certificate ?  await getFileFromBlobUrl(values.certificate) : '',
      partnership_invoice: values.partnership_invoice ? await getFileFromBlobUrl(values.partnership_invoice) : '',
      to_email: values.email
    }
    dispatch(createWithdrawPayPal(extractFormData(payload)))
  }
  const resetForm = () => {
    form.resetFields()
    dispatch(resetWithdrawPayPalState())
    handleCancel()
  }

  useEffect(() => {
    if (success) {
      dispatch(getBalance())
      showNotification('success', t('Summary.WithdrawSuccess'))
      resetForm()
    }
    if (error){
      showNotification('error', t('Error'))
      resetForm()
    }
  }, [dispatch, success, error])
  const isPartnerOrAffiliate = user.is_partner || user.is_affiliate
  const handleCheck =(e) => { setShowInvoiceField(e.target.checked) }
  const showInvoiceInput = isPartnerOrAffiliate && (!user.is_project_developer ||showInvoiceField)
  return <Form
    name='basic'
    autoComplete='off'
    form={form}
    onFinish={onSubmit}
  >
    {/* Email */}
    <CustomText label={t('Summary.Email')} />
    <CustomTextInput name='email'  placeholder={t('Summary.Email')} type='email' required />

    {/* Certificate */}
    <CustomText label={t('Summary.AccountCertificate')} />
    <CustomFileInput name='certificate' required />

    {/* PartneShip Invoice */}

    {isPartnerOrAffiliate && user.is_project_developer && <>
      <Checkbox className='mb-5' checked={showInvoiceField} onChange={handleCheck}>
        {t('Summary.PartnershipCheckbox')}
      </Checkbox>
    </>}
    {showInvoiceInput && <>
      <CustomText label={t('Summary.PartnershipInvoice')} />
      <CustomFileInput name='partnership_invoice' required />
    </>}

    {/* Button */}
    <Button
      block
      size='large'
      type='primary'
      loading={loading}
      htmlType='submit'
      className='radius-100'
    >{t('Summary.Withdraw')}
    </Button>
  </Form>
}

export default WithDrawPayPalForm
